import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const Kinetik2026LogoIcon = ({
  color = 'var(--color-brand-400)',
  ...props
}) => (
  <SvgIcon viewBox="0 0 20 21.163" {...props}>
    <path
      d="M5.82473 6.05383V0H0V11.8475C1.29503 9.86515 3.16477 7.8828 5.82473 6.05189V6.05383Z"
      fill={color}
    />
    <path
      d="M5.82473 20.969H0C0 15.7947 2.59395 11.4514 7.71 8.05754C12.3096 5.00733 12.8125 3.17642 12.8125 0H18.6372C18.6372 5.75677 16.6199 9.13512 10.9311 12.9115C7.44789 15.222 5.82667 17.7829 5.82667 20.969H5.82473Z"
      fill={color}
    />
    <path
      d="M15.5328 21.163C17.4629 21.163 19.0276 19.5983 19.0276 17.6682C19.0276 15.738 17.4629 14.1733 15.5328 14.1733C13.6027 14.1733 12.038 15.738 12.038 17.6682C12.038 19.5983 13.6027 21.163 15.5328 21.163Z"
      fill={color}
    />
  </SvgIcon>
);

Kinetik2026LogoIcon.propTypes = {
  color: PropTypes.string,
};

export default Kinetik2026LogoIcon;
